var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14C14.5523 14 15 14.4477 15 15V27H25V15C25 14.4477 25.4477 14 26 14C26.5523 14 27 14.4477 27 15V27C27 28.1046 26.1046 29 25 29H15C13.8954 29 13 28.1046 13 27V15C13 14.4477 13.4477 14 14 14Z",
    fill: "#008C15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14C11 13.4477 11.4477 13 12 13L28 13C28.5523 13 29 13.4477 29 14C29 14.5523 28.5523 15 28 15L12 15C11.4477 15 11 14.5523 11 14Z",
    fill: "#008C15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12C15 10.8954 15.8954 10 17 10H23C24.1046 10 25 10.8954 25 12V14C25 14.5523 24.5523 15 24 15C23.4477 15 23 14.5523 23 14V12H17V14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14V12Z",
    fill: "#008C15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGreen);
export default __webpack_public_path__ + "static/media/DeleteGreen.3617967cec5d0cf6b61ef9003d604252.svg";
export { ForwardRef as ReactComponent };